import React, { memo } from 'react';
import { IconCalendar } from '@tabler/icons-react';
import '../../../Common/Filters/PeriodIndicator.css';
import { useCensusFiltersContext } from './hooks/useCensusFiltersContext';

// Mesmo visual do PeriodIndicator dos outros dashboards, mas por ano: o Censo não tem dados mensais.
const CensusYearIndicator = ({ className = '' }) => {
    const { filters, yearOptions, hasCensusData } = useCensusFiltersContext();

    if (!hasCensusData) {
        return (
            <div className={`period-indicator period-indicator--empty ${className}`}>
                <IconCalendar size={18} className="period-indicator__icon" />
                <span className="period-indicator__item">
                    Nenhum dado do Censo importado para esta cidade.
                </span>
            </div>
        );
    }

    return (
        <div className={`period-indicator ${className}`}>
            <IconCalendar size={18} className="period-indicator__icon" />
            <span className="period-indicator__item">
                Ano do Censo: <strong>{filters.year.label}</strong>
            </span>
            <span className="period-indicator__divider" aria-hidden="true" />
            <span className="period-indicator__item period-indicator__item--muted">
                Anos disponíveis:{' '}
                <strong>{yearOptions.map((option) => option.label).join(', ') || '—'}</strong>
            </span>
        </div>
    );
};

export default memo(CensusYearIndicator);
